// @flow
import EditableProp from './EditableProp';

export default EditableProp;
